
import { defineComponent } from 'vue'
import { loadCookiePolicyContent } from '@/config/documentLoader'

import Header from '@/components/Home/Header.vue'
import setMeta from '@/scripts/root/setMeta'
import content from './Content.vue'

export default defineComponent({
  components: {
    Header,
  },
  data() {
    return {
      cookiePolicyContent: '',
    }
  },
  computed: {
    currentLanguage(): string {
      return this.$store.getters.getAppLanguage
    },
  },
  methods: {
    setMeta,
    content,
    formattedValue(value: string) {
      let formattedText = value.replace(/\n/g, '<br/>')
      return formattedText.replace(
        /\[(.*?)\]\((.*?)\)/g,
        '<a href="$2" target="_blank" class="dynamic-link">$1</a>'
      )
    },
  },
  watch: {
    currentLanguage(newVal) {
      this.cookiePolicyContent = loadCookiePolicyContent(newVal)
    },
  },
  mounted() {
    this.cookiePolicyContent = loadCookiePolicyContent(this.currentLanguage)
  },
})
